
import {ProductReview} from './product-review';

export enum QueryPage {
  First = 1,
  Previous,
  Next,
  Last
}

export class ReviewQuery {

  static skipCountParamName = 'skip';
  static skipLimitParamName = 'limit';
  static resultLimit = 5;

  results: ProductReview[] = [];
  maxStars: number;

  resultCount: number;
  resultSkip: number;

  totalReviewsCount: number;

  firstPageURLParams: string;
  prevPageURLParams: string;
  nextPageURLParams: string;
  lastPageURLParams: string;

  currentPageNumber() {
    return (this.resultSkip > 0) ? Math.ceil(this.resultSkip / ReviewQuery.resultLimit) + 1 : 1;
  }

  queryParamsForPageType(pageType: QueryPage) {
    switch (pageType) {
      case QueryPage.First: {
        return this.firstPageURLParams;
      }
      case QueryPage.Previous: {
        return this.prevPageURLParams;
      }
      case QueryPage.Next: {
        return this.nextPageURLParams;
      }
      case QueryPage.Last: {
        return this.lastPageURLParams;
      }
      default: {
        return null;
      }
    }
  }

  loadResults(data: any) {
    if (data) {
      const json: JSON = data;
      this.maxStars = json['scaleMax'];

      if (json['paging']) {
        const pagingJSON = json['paging'];
        this.resultCount = pagingJSON['returnedReviewsCount'];
        this.resultSkip = pagingJSON['skip'];
        this.totalReviewsCount = pagingJSON['totalReviewsCount'];
        this.firstPageURLParams = this.formatPageParamString(pagingJSON['firstPage']);
        this.prevPageURLParams = this.formatPageParamString(pagingJSON['prevPage']);
        this.nextPageURLParams = this.formatPageParamString(pagingJSON['nextPage']);
        this.lastPageURLParams = this.formatPageParamString(pagingJSON['lastPage']);
      }

      if (json['reviews']) {
        this.results = [];
        for (const review of json['reviews']) {
          this.results.push(new ProductReview(review));
        }
      }
    }
  }

  formatPageParamString(data: any) {
    const json: JSON = data;
    if (json) {
      return  ReviewQuery.skipCountParamName + '=' + json['skip'] + '&' + ReviewQuery.skipLimitParamName + '=' + json['limit'];
    }
    return null;
  }
}




// WEBPACK FOOTER //
// ./src/app/model/product-review-query.ts